import React from 'react';

export interface OptionButtonsProps {
  title: string;
  background: string;
  onPress: () => void;
  icon: JSX.Element;
}

export const SwipeOptionButtons: React.FC<{
  options: OptionButtonsProps[];
}> = ({ options }) => {
  return (
    <div className="conversation-card-swipeable-btn-list font-semibold">
      {options.map((item, index) => (
        <OptionButtons key={index} {...item} />
      ))}
    </div>
  );
};

const OptionButtons: React.FC<OptionButtonsProps> = ({
  background,
  title,
  icon,
  onPress,
}) => {
  return (
    <div className="option-button" onClick={onPress} style={{ background }}>
      <div className="btn-icon">{icon}</div>
      <div className="btn-label">{title}</div>
    </div>
  );
};
